export default __webpack_public_path__ + "static/media/comillas-cierre.13572d46.svg";